import React from "react";
import "./src/styles/global.css";
import WhatsAppFloat from "./src/components/WhatsAppFloat";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <WhatsAppFloat />
  </>
);
